/**
 * Gigya (SAP CDC) result code. `0` means success; any other value is a failure.
 * Source of truth for all Gigya callback checks across the webapp.
 * @see GigyaResponse.errorCode in @gigya-ts/rest-api
 * @see https://help.sap.com/docs/SAP_CUSTOMER_DATA_CLOUD/8b8d6fffe113457094a17701f63e3d6a/416d41b170b21014bbc5a10ce4041860.html
 */
export const GIGYA_SUCCESS_CODE = 0;
